import { render, staticRenderFns } from "./NxCustomers.vue?vue&type=template&id=06bc1096&scoped=true"
import script from "./NxCustomers.vue?vue&type=script&lang=js"
export * from "./NxCustomers.vue?vue&type=script&lang=js"
import style0 from "./NxCustomers.vue?vue&type=style&index=0&id=06bc1096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc1096",
  null
  
)

export default component.exports